/**
 * Created by Administrador on 24/07/2019.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('transferenceCtrl', transferenceCtrl);

    transferenceCtrl.$inject = ['$stateParams', 'tabs', 'datePickerService', 'flightService',
        'linkService','cargoReportService','branchOffices','dateService','printService'];

    function transferenceCtrl($stateParams, tabs, datePickerService, flightService, linkService, cargoReportService,
                              branchOffices,dateService,printService){
        var vm = this;

        vm.linkService = linkService;
        vm.tabs = tabs;
        vm.flights = [];
        vm.branchOffices = branchOffices.data._embedded ? branchOffices.data._embedded.branchOffices: [];
        vm.report = undefined;
        vm.departureDate = new Date();
        vm.filter =
            {
                "out" : true
            }

        vm.dateParam = $stateParams.date;
        vm.datePickerOpenStatus = {'date': false};
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.datepickerFrom = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false
            }
        };

        vm.openCalendar = function(date){
            vm.datePickerOpenStatus[date] = true;
        }

        vm.eventChangeDepartureDate = function(){
            vm.report = undefined;
            if(vm.departureDate != undefined && vm.branchOffice != undefined){
                vm.flights= [];
                flightService.getFlightByDepartureDateAndOrigin(vm.departureDate.getTime(),linkService.getLinkId(vm.branchOffice._embeddeds.airport._links.self.href))
                    .then(function (response) {
                        angular.forEach(response, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials
                            });
                        });
                    });
            }
        }

        vm.onChangeReport = function(){
            vm.report = undefined;
        }

        vm.exportPdf = function(reducedPrint){
            reportService.getGeneralManifestPdf(vm.flight.departureFlightId,reducedPrint,vm.flight.flightId,vm.flight.departureFlightOrder)
                .then(function (response) {
                    if(response == undefined){
                        vm.report = undefined;
                    }else{
                        var file = new Blob([response.data], {type: 'application/pdf;base64'});
                        var nameFile = "general_manifest_"+(reducedPrint?"r":"n")+".pdf";
                        var date = moment().format('YYYY_MM_DD');

                        if (window.navigator && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveBlob(file, nameFile);
                        }else{
                            var fileURL = URL.createObjectURL(file);
                            var a = document.createElement('a');
                            a.href = fileURL;
                            a.target = '_blank';
                            a.download = nameFile;
                            document.body.appendChild(a);
                            a.click();
                        }
                    }
                });
        }

        vm.cancel = function() {
            linkService.reloadRoute(linkService.getCurrentRouteName(), {})
        };

        vm.getReport = function(){
            if(vm.branchOfficeOrigin != undefined && vm.branchOfficeDestiny != undefined){
                cargoReportService.getTransference(vm.linkService.getLinkId(vm.branchOfficeOrigin._links.self.href),
                    vm.linkService.getLinkId(vm.branchOfficeDestiny._links.self.href),
                    vm.filter.out,dateService.dateTimeString(vm.departureDate, 1))
                    .then(function (response) {
                        if(response == undefined){
                            vm.report = undefined;
                        }else{
                            vm.report = response.data;
                        }
                    });
            }
        }

        vm.generatePdfHtml = function (target) {
            printService.printPdfHtml(target);
        }
    }
})();
